import defaultImage from 'assets/images/banner.jpeg';

// Quarks
import Flex from 'quarks/Flex';
import Heading from 'quarks/Heading';
import Image, { ImageData } from 'quarks/Image';
import Text from 'quarks/Text';

// Types
import type { ContentfulEntityPerson } from 'graphqlTypes';
import type { FC } from 'react';

interface BasicCardProps
  extends Omit<ContentfulEntityPerson, 'id' | 'children' | 'contentful_id' | 'internal' | 'node_locale'> {
  backgroundIsDark: boolean;
}

const BasicCard: FC<BasicCardProps> = ({ name, headshot, position, backgroundIsDark, ...props }) => (
  <Flex
    width="100%"
    height="100%"
    flexDirection="column"
    overflowX="hidden"
    overflowY="hidden"
    transition="200ms ease-in-out"
    backgroundColor={backgroundIsDark ? 'gray-900' : 'common-white'}
    {...props}
  >
    {headshot ? (
      <Image
        image={headshot as ImageData}
        alt={headshot?.title || 'Blog Card Image'}
        objectFit="cover"
        objectPosition="center"
        minHeight="400px"
        maxHeight="400px"
      />
    ) : (
      <Image
        image={{ file: { url: defaultImage } }}
        alt="Blog Card Image"
        objectFit="cover"
        objectPosition="center"
        minHeight="400px"
        maxHeight="400px"
      />
    )}
    <Flex
      position="relative"
      flexDirection="column"
      justifyContent="space-between"
      paddingY={24}
      paddingX={24}
      gap="16px"
      height="100%"
      maxHeight="fit-content"
      sm={{ maxHeight: 'calc(100% - 208px)' }}
    >
      <Flex flexDirection="column" gap="8px" textAlign="center">
        {name && (
          <Heading
            as="h4"
            fontSize="h6"
            lineHeight="h6"
            fontWeight="semiBold"
            textColor={backgroundIsDark ? 'common-white' : 'gray-900'}
          >
            {name}
          </Heading>
        )}
        {position && (
          <Text textStyle="textLg" textColor={backgroundIsDark ? 'gray-200' : 'gray-900'}>
            {position}
          </Text>
        )}
      </Flex>
    </Flex>
  </Flex>
);

export default BasicCard;
